import api from '@/api';
import { message } from 'antd';

const newsModel = {
    name: 'news',
    state: {
        categories: {},
        data: [],
        loading: false,
        error: false,
    },

    reducers: {
        setCategories(state, payload) {
            return { ...state, categories: payload };
        },
        setData(state, payload) {
            return { ...state, data: payload };
        },
        setLoading(state, payload) {
            return { ...state, loading: payload };
        },
        setError(state, payload) {
            return { ...state, error: payload };
        },
    },

    effects: dispatch => ({
        async fetch() {
            this.setLoading(true);
            this.setError(false);

            try {
                const { data, categories } = await api.tree.fetchNews();
                console.log('data, categories', [data, categories]);
                dispatch.news.setCategories(categories);
                dispatch.news.setData(data);
            } catch (error) {
                message.error('Не удалось получить новости');
                console.error(error);
                dispatch.news.setError(true);
            } finally {
                dispatch.news.setLoading(false);
            }
        },
    }),

    selectors: slice => ({
        hasNews() {
            return slice(state => state.groups.length > 0);
        },
    }),
};

export default newsModel;
